<script>
    import {onMount} from 'svelte';
    import Loader from "../components/Loader.svelte";
    import ChartsService from "../services/charts.service";
    import {formatValue} from "../helpers/format.helper";
    import Chart from 'svelte-frappe-charts';

    let data = [],
        loading = true,
        reportName;

    export let user, params;

    $: loadData(params);

    onMount(() => {
        loadData(params);
    });

    async function loadData() {
        if(params.org != 0){
            loading = true;
            data = null;
            let result = null;
            reportName = params.subMenu;

            try {
                result = await ChartsService.load(params.org, params.subMenu, params.year);
            } catch (e) {
                console.log('Error:', e);
            }

            if (result && result.data) data = result.data;
            loading = false;
        }else{
            loading = false;
        }
    }

    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    function getRevenueComparison(rows) {
        let datasets = [
            {
                name: 'Revenue Closed',
                values: []
            },
            {
                name: 'Budget',
                values: []
            }
        ];

        Object.keys(rows).map((id) => {
            datasets[0].values.push(rows[id].actual);
            datasets[1].values.push(rows[id].budget);
        });

        return {
            labels: months,
            datasets
        };
    }

    function getRevenueSingle(rows) {
        let datasets = [
            {
                name: 'Revenue Closed',
                values: []
            }
        ];

        Object.keys(rows).map((id) => {
            datasets[0].values.push(rows[id].actual);
        });

        return {
            labels: months,
            datasets
        };
    }

    function getWinRateAverage(rows) {
        let avg = 0;
        let count = 0;

        rows.data.map((val) => {
            avg += val.actual;

            if (val.actual > 0) {
                count++;
            }
        });

        return formatValue(2, avg / count) || '-';
    }

    function getWinRate(rows) {
        let datasets = [
            {
                name: 'Win Rate',
                values: []
            }
        ];
        let companies = [];
        let count = 0;

        Object.keys(rows).map((id) => {
            let avg = 0;

            rows[id].data.map((val) => {
                avg += val.actual;

                if (val.actual > 0) {
                    count++;
                }
            });

            companies.push(rows[id].name);
            datasets[0].values.push(avg / count);
        });

        return {
            labels: companies,
            datasets
        };
    }

    function getChartData(rows) {
        let datasets = [];

        Object.keys(rows).map((id) => {
            let values = [];

            rows[id].data.map((val) => {
                values.push(val.actual);
            });

            datasets.push({
                name: rows[id].name,
                values: values
            });
        });

        return {
            labels: months,
            datasets
        };
    }
</script>
{#if loading}
    <Loader></Loader>
{:else}
    {#if params.org == 0 || !data.orgs}
        <h3 class="text-center text-primary">Please select an organization from the dropdown</h3>
    {:else}
        <div class="table-wrapper">
            {#if params.subMenu == '4'}
                {#each Object.keys(data.orgs) as org}
                    {#if data.orgs[org].data}
                        <h3>{data.orgs[org].name}</h3>
                        <table class="table table-sm container-fluid table-weekly selectable-table sticky-enabled">
                            <thead>
                                <tr class="bg-dark text-light">
                                    <th>&nbsp;</th>
                                    {#each months as month}
                                        <th>{month}</th>
                                    {/each}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th class="text-left">Actual</th>
                                    {#each months as month, id}
                                        <td class="readOnly">{formatValue(data.orgs[org].format, data.orgs[org].data[id].actual)}</td>
                                    {/each}
                                </tr>
                                <tr>
                                    <th class="text-left">Budget</th>
                                    {#each months as month, id}
                                        <td class="readOnly">{formatValue(data.orgs[org].format, data.orgs[org].data[id].budget)}</td>
                                    {/each}
                                </tr>
                            </tbody>
                        </table>
                        <div class="row">
                            <div class="col-6">
                                <Chart data={getRevenueComparison(data.orgs[org].data)} type="line"></Chart>
                            </div>
                            <div class="col-6">
                                <Chart data={getRevenueSingle(data.orgs[org].data)} type="bar"></Chart>
                            </div>
                        </div>
                        <hr class="mb-5">
                    {/if}
                {/each}
            {:else}
                <table class="table table-sm container-fluid table-weekly selectable-table sticky-enabled">
                    <thead>
                        <tr class="bg-dark text-light">
                            <th>Company</th>
                            {#if params.subMenu == '8'}
                                <th>Average</th>
                            {/if}
                            {#each months as month}
                                <th>{month}</th>
                            {/each}
                        </tr>
                    </thead>
                    <tbody>
                        {#if data.orgs}
                            {#each Object.keys(data.orgs) as org}
                                {#if data.orgs[org].data}
                                    <tr>
                                        <th class="text-left">{data.orgs[org].name}</th>
                                        {#if params.subMenu == '8'}
                                            <th>{getWinRateAverage(data.orgs[org])}</th>
                                            {#each months as month, id}
                                                <td class="readOnly">{formatValue(data.orgs[org].format, data.orgs[org].data[id].actual)}</td>
                                            {/each}
                                        {:else}
                                            {#each months as month, id}
                                                <td class="readOnly">{formatValue(data.orgs[org].format, data.orgs[org].data[id].actual)}</td>
                                            {/each}
                                        {/if}
                                    </tr>
                                {/if}
                            {/each}
                        {:else}
                            <h4 class="text-danger">No organization selected.</h4>
                        {/if}
                    </tbody>
                </table>

                <div class="row">
                    <div class="col-10 offset-1">
                        {#if params.subMenu == '8'}
                            <Chart data={getWinRate(data.orgs)} type="bar"></Chart>
                        {:else}
                            <Chart data={getChartData(data.orgs)} type="{ params.subMenu == '6'?'bar': 'line'}"></Chart>
                        {/if}
                    </div>
                </div>
            {/if}
        </div>
    {/if}
{/if}
